import { render, staticRenderFns } from "./HandleMailNotifications.vue?vue&type=template&id=73b021c6"
import script from "./HandleMailNotifications.vue?vue&type=script&lang=js"
export * from "./HandleMailNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports